import { useEffect } from "react";
import { useCartData } from "@/zustand/cartStore.js";
import { useTemplateStore } from "@/zustand/templateStore.js";
import { usePopupStore } from "@children/zustand/popupStore.js";
import Button from "@children/components/buttons/Button.jsx";
import s from "./AmountUpsellPopup.module.scss";
import Countdown from "@children/components/Countdown";
import parse from "html-react-parser";

const AmountUpsellPopup = () => {
  const { setLoadingState, isMobile } = useTemplateStore();
  const { amountPopup, disableUpellPopup } = usePopupStore();
  const { selectedProduct, setSelectedProduct } = useCartData();
  const form = window.post_template?.checkout_v4_form;
  /* Product data */
  const productImage = window.checkout_popup?.amount_upsell_product_image;
  const productPrice = window.checkout_popup?.amount_upsell_product_price;
  const productOldPrice = window.checkout_popup?.amount_upsell_product_old_price;
  const checkoutTemplate = window.post_template.checkout_v4_meta_bars;
  const onlyLabel = checkoutTemplate.tr_checkout_v4_meta_bars_only_label;
  const leftInStock = checkoutTemplate.tr_checkout_v4_meta_bars_leftInStock_label;
  const itemLabel = checkoutTemplate.tr_checkout_v4_meta_bars_itemsLabel;

  /* Colors */
  const modalBgColor = window.checkout_popup?.amount_upsell_bg_color;
  const itemsLeftBgColor = window.checkout_popup?.amount_upsell_items_left_bg_color;
  const productCardBorderColor = window.checkout_popup?.amount_upsell_product_card_border_color;
  const productCardBgColor = window.checkout_popup?.amount_upsell_product_card_bg_color;
  const itemsLeftTextColor = window.checkout_popup?.amount_upsell_items_left_text_color;
  const noThanksLinkColor = window.checkout_popup?.amount_upsell_no_thanks_link_color;
  const priceColor = window.checkout_popup?.amount_upsell_price_color;
  const productCardLabelTextColor = window.checkout_popup?.amount_upsell_product_card_label_text_color;
  const textColorPrimary = window.checkout_popup?.amount_upsell_text_color_primary;
  const textColorSecondary = window.checkout_popup?.amount_upsell_text_color_secondary;
  const textColorDimmed = window.checkout_popup?.amount_upsell_text_color_dimmed;
  document.documentElement.style.setProperty("--upsell-popup-bg-color", modalBgColor);
  document.documentElement.style.setProperty("--items-left-bg-color", itemsLeftBgColor);
  document.documentElement.style.setProperty("--product-card-border-color", productCardBorderColor);
  document.documentElement.style.setProperty("--product-card-bg-color", productCardBgColor);
  document.documentElement.style.setProperty("--items-left-text-color", itemsLeftTextColor);
  document.documentElement.style.setProperty("--no-thanks-link-color", noThanksLinkColor);
  document.documentElement.style.setProperty("--price-color", priceColor);
  document.documentElement.style.setProperty("--product-card-label-text-color", productCardLabelTextColor);
  document.documentElement.style.setProperty("--text-primary-color", textColorPrimary);
  document.documentElement.style.setProperty("--text-secondary-color", textColorSecondary);
  document.documentElement.style.setProperty("--text-dimmed-color", textColorDimmed);

  // Left in stock calculation
  const randomTotalSupply = window.checkout_popup?.amount_upsell_product_total_supply;
  const itemsLeft = window.checkout_popup?.amount_upsell_product_current_stock;
  const percents = calculatePercentageDecrease(itemsLeft, randomTotalSupply);

  function calculatePercentageDecrease(itemsLeft, randomTotalSupply) {
    if (!itemsLeft || !randomTotalSupply) return 0;
    const newPercentage = (itemsLeft * 100) / randomTotalSupply;
    return 100 - newPercentage;
  }

  useEffect(() => {
    if (amountPopup?.displayPopup) {
      document.body.style.setProperty("overflow", "hidden", "important");
    } else {
      document.body.style.removeProperty("overflow");
    }

    return () => {
      document.body.style.removeProperty("overflow");
    };
  }, [amountPopup?.displayPopup]);

  const primaryProduct = selectedProduct?.bundle_products?.find((product) => product.primary_product === true);
  const modifiedBundleProducts = selectedProduct.bundle_products?.map((product) => {
    if (product === primaryProduct) {
      return {
        ...product,
        bp_price: productPrice,
        bp_amount: window?.checkout_popup?.amount_upsell_product_qty,
      };
    } else {
      return product;
    }
  });

  const handleUpsellClick = () => {
    setSelectedProduct({
      ...selectedProduct,
      price: productPrice,
      old_price: productOldPrice,
      amount: window?.checkout_popup?.amount_upsell_product_qty,
      bundle_products: modifiedBundleProducts,
    });
    disableUpellPopup();
    setLoadingState(true);
  };

  const closeUpsellPopup = () => {
    disableUpellPopup();
  };

  useEffect(() => {
    setTimeout(() => {
      closeUpsellPopup();
    }, [window.checkout_popup?.amount_upsell_submit_without_upsell * 1000 || 10000]);
  }, []);
  return (
    <div className={`upsellPopup upsells-modal__wrapper upsells-modal__wrapper--active ${s.upsellPopup}`}>
      <div className={`upsellPopup__heading ${s.heading}`}>
        {isMobile
          ? parse(window.checkout_popup?.amount_upsell_heading_mobile)
          : parse(window.checkout_popup?.amount_upsell_heading)}
      </div>
      <div className={`upsellPopup__content ${s.content}`}>
        <div className={`upsellPopup__image--desktop ${s.imgContainer}`}>
          <img
            src={productImage}
            className={`upsellPopup__image mon-img-150-w ${s.image}`}
            alt={`${general_settings.brand_name} image`}
          />
        </div>
        <div style={isMobile ? { width: "100%" } : {}}>
          <div
            className={`productListPopup__item productListPopup__item--enabledBorder productList__item--enabledBorder productListPopup__item--SDCard ${s.itemContainer}`}
          >
            <div className={`productListPopup__popular productListPopup__popular--enabled ${s.popularText}`}>
              {window.checkout_popup?.amount_upsell_exclusive_deal_label}
            </div>
            <div className={`productListPopup__contentDiff ${s.contentDiff}`}>
              <div className={s.priceDiff}>
                {isMobile && (
                  <img
                    src={productImage}
                    className={`mon-img-150-w ${s.mobileImage}`}
                    alt={`${general_settings.brand_name} image`}
                  />
                )}
                <span className={`product-card-price ${s.cardPrice}`}>{`$${productPrice}`}</span>
                <span className={s.oldPrice}>{productOldPrice}</span>
                <span></span>
                <span className={s.eachLabel}>{window.checkout_popup?.amount_upsell_each_label}</span>
              </div>
              <span className={s.upgradeText}>{window.checkout_popup?.amount_upsell_product_desc}</span>
              <div className={s.youSaveLabel}>{window.checkout_popup?.amount_upsell_save_label}</div>
              <Countdown />
            </div>
          </div>
          <div key="stock" className={s.barsContainer}>
            <div className={s.barsLeftText}>
              {onlyLabel} <span className={s.barsLeftTextRed}>{itemsLeft}</span> {itemLabel}
            </div>
            <span className="bars__bar_1__colorBar">
              <span className={`bars__bar_1__colorBar_colored `} style={{ width: `${percents}%` }}></span>
            </span>
            <div className={s.barsRightText}>{leftInStock}</div>
          </div>
          <Button
            margin={16}
            text={window.checkout_popup?.amount_upsell_cta_text}
            processingLabel={form?.tr_checkout_v4_form_processing}
            loading={false}
            handleClick={handleUpsellClick}
          />
          <a
            className={s.declineUpsellButton}
            href="#"
            onClick={(e) => {
              e.preventDefault();
              disableUpellPopup();
            }}
          >
            {window.checkout_popup?.amount_upsell_no_thanks_link_label}
          </a>
        </div>
      </div>
    </div>
  );
};

export default AmountUpsellPopup;
